export { default } from "./CompanyProfile"
